import React, { memo, useEffect } from "react";
import storiesFooterImg1 from "../../../../assets/image/stories-footer-image-1.png";
import storiesFooterImg2 from "../../../../assets/image/stories-footer-image-2.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchStories, getImageUrl } from "../../../../api/leads";
import rightCarouselIcon from "../../../../assets/image/right-carousel-icon.png";

export default function ({ stories }) {

    // console.log("DataRenderer is rendering...");
    const randomStories = (data) => {
        const matchId = location.pathname.split('/')
        const currentId = matchId[3]
        const allids = data.map((item => item.localstories.id))
        const availableIds = allids.filter(id => id != currentId)
        const getRandomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];


        let id1 = getRandomItem(availableIds);
        let id2 = getRandomItem(availableIds);


        if (id1 === id2) {
            id2 = getRandomItem(availableIds);
        }
        const storyObject1 = data.find(item => item.localstories.id === id1);
        const storyObject2 = data.find(item => item.localstories.id === id2);
        return [storyObject1, storyObject2];
    }
    const twoStories = randomStories(stories);

    return (
        <>
            {/* Stories pages Footer start */}
            <section className="stories-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="story-header-content-1 d-flex justify-content-between align-items-start">
                                <h1 className="stories-footer-heading">
                                    More Stories You'll Enjoy
                                </h1>
                                <Link replace to={"/local"} className="all-stories-link">
                                    SEE ALL STORIES{" "}
                                    <img
                                        src={rightCarouselIcon}
                                        alt="right Carousel Icon"
                                        className="all-stories-icon"
                                    />
                                </Link>
                            </div>
                        </div>
                        {twoStories.map((item) => (
                            <div key={item.localstories.foldername} className="col-md-6">
                                <div className="d-flex align-items-center gap-4 story-img-container">
                                    <img src={getImageUrl(item.localstories.foldername, item.localstories.thumbnail)} alt="" className="stories-img" />
                                    <div className="d-flex flex-column gap-3">
                                        <p className="stories-sub-heading">
                                            {item.localstories.subtitle}
                                        </p>
                                        <Link replace to={`/local/${item.localstories.storyname}`} className="read-more-link">
                                            READ MORE
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}


                    </div>
                </div>
                {/* {stories.map((item) => (
                    <div className="col-md-6">
                        <div className="d-flex align-items-center gap-4">
                            <img src={getImageUrl(item.localstories.foldername, item.localstories.thumbnail)} alt="" className="stories-img" />
                            <div className="d-flex flex-column gap-3">
                                <p className="stories-sub-heading">
                                    {item.localstories.subtitle}
                                </p>
                                <Link to={`/local/stories/${item.localstories.id}`} className="read-more-link">
                                    READ MORE
                                </Link>
                            </div>
                        </div>
                    </div>
                ))} */}
            </section>
            {/* Stories pages Footer end */}
        </>
    )
}

